import {Track} from '@app/web-player/tracks/track';
import {slugifyString} from '@ui/utils/string/slugify-string';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';

export function getTrackLink(
  track: Pick<Track, 'id' | 'name'>,
  {absolute}: {absolute?: boolean} = {},
): string {
  let link = `/track/${track.id}/${slugifyString(track.name)}`;
  if (absolute) {
    link = `${getBootstrapData().settings.base_url}${link}`;
  }
  return link;
}
